import { clsx } from 'clsx';
import { CSSProperties } from 'react';
import styles from './ActionBadge.module.scss';

interface ActionBadgeProps {
  children: React.ReactNode;
  style?: CSSProperties;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'default' | 'primary';
  dataTestId?: string;
}

export const ActionBadge = ({
  children,
  className,
  style,
  dataTestId,
  size = 'sm',
  variant = 'default',
}: ActionBadgeProps) => {
  return (
    <div
      className={clsx(styles.badge, styles[size], styles[variant], className)}
      style={style}
      data-testid={dataTestId}
    >
      {children}
    </div>
  );
};
